import Footer from "./components/footer";
import Aboutus from "./pages/aboutus";
import Navbar from "./components/navbar";
import Services from "./pages/services";
import Contacts from "./pages/contacts";
import Prices from "./pages/prices";
import Home from "./pages/home";
import Feedback from "./pages/feedback";
import { FaWhatsapp } from "react-icons/fa";

function App() {

  const handleWhatsAppClick = () => {
    const phoneNumber = '96176909514'; // No "+" or special characters
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  return (
    <div className="w-full h-full flex flex-col">
      <Navbar />
      <Home />
      <Aboutus />
      <Services />
      <Prices />
      <Feedback />
      <Contacts />
      <Footer />
      <button
        className="lg:hidden fixed bottom-4 right-2 w-20 h-20 bg-green-500 text-white rounded-full flex items-center justify-center"
        onClick={handleWhatsAppClick}
      >
        <FaWhatsapp size={50} />
      </button>
    </div>
  );
}

export default App;
